import type { PartialDeep } from "type-fest";

import type { Common } from "./common.js";

export default {
  role: {
    officer: "BTP Officer",
    commandunit: "Sub-Divisional Command Unit",
  },
  incidentWorkItem: {
    commandUnit: "Sub-Division",
    geographicUnit: "Sector ID",
    type: {
      voluntary: "Voluntary Support",
    },
  },
  userProfile: {
    shoulderNumber: "Police Number",
  },
  common: {
    dispatchNumber: "Control Works Number",
    shoulderNumber: "Police Number",
  },
  fieldSchema: {
    dispatchNumber: {
      tooShort: "$t(common.dispatchNumber) must be at least 3 characters",
    },
  },
  createIncident: {
    dispatchNumber: {
      label: "$t(common.dispatchNumber) - reference only",
      placeholder: "e.g. 123",
    },
    dispatchNumberCreated: "Date of $t(common.dispatchNumber) creation",
    personForename: "Person's given names",
  },
  leavePlaceOfSafety: {
    didYouLeave: "Have you moved the patient to another place of safety?",
    didYouLeave_136: "Have you moved the patient to another place of safety?",
    leaveReason: {
      title: "Why was the patient moved?",
    },
  },
  detentionDetails: {
    custodyNumber: "Custody Number",
    dateOfDetention: "Date of detention",
    timeOfDetention: "Time of detention",
    custodyNumberDescriptionBanner:
      "Enter the custody number associated with this incident. Format is two digit Force Code with two letter detention suite, up to 7 digit serial number (leading zeros are omitted) followed by two digit year element (eg. 01AA/1111/21)",
    commandUnit:
      "In which $t(incidentWorkItem.commandUnit) did the incident take place?",
    commandUnitRequired:
      "Please confirm in which $t(incidentWorkItem.commandUnit) the incident took place",
  },
  mcaIncidentDetails: {
    bcuIncidentTookPlace:
      "In which $t(incidentWorkItem.commandUnit) did the incident happen?",
    bcuIncidentTookPlaceRequired:
      "Please select the $t(incidentWorkItem.commandUnit) where the incident happened",
  },
  mcaCapacityAssessment: {
    assessingIndividualDescriptionBanner:
      "This could be yourself, Ambulance Service or someone else. If another officer is the decision maker you may wish to transfer the form to them to complete. ",
    useOfForceType: {
      options: {
        dogs: "Dog deployment",
        baton: "Baton - drawn or used",
        irritantSpray: "Captor - drawn or used",
        ced: "Taser",
        unarmedSkills: "Unarmed skills",
      },
    },
  },
  informationForHealthcare: {
    useOfForceContextIrritantSpray: {
      title: "In what context did you draw or use Captor?",
      required: "Please select the context in which Captor was drawn or used",
    },
    useOfForceContextDogs: {
      title: "In what context was a dog deployed?",
      required: "Please select the context in which a dog was deployed",
    },
    useOfForceContextCed: {
      title: "In what context did you use a Taser?",
      required: "Please select the context in which a Taser was used",
    },
    useOfForceContextUnarmedSkills: {
      title: "In what context did you use unarmed skills?",
      required: "Please select the context in which unarmed skills were used",
    },
    useOfForceType: {
      options: {
        dogs: "Dog deployment",
        baton: "Baton - drawn/used",
        irritantSpray: "Captor - drawn or used",
        ced: "Taser",
        unarmedSkills: "Unarmed skills",
        otherImprovised: "Other/improvised",
      },
    },
    wasHealthcareProvided:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or 136 Suite)?",
    wasHealthcareProvided_136:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or 136 Suite)?",
    wasHealthcareProvided_mca:
      "Was physical health care provided prior to arrival at the Emergency Department?",
    wasForceUsed: "Was restraint used?",
    didSeizeProperty: "Did you seize any items (e.g. weapons or drugs)?",
    detailsPropertySeized:
      "Please provide detail of the items seized (e.g. weapons or drugs)",
    describeRiskFactorsOther: "Please specify",
  },
  personDetails: {
    ethnicity: {
      options: {
        IC1: "IC1 - North European",
        IC2: "IC2 - South European",
        IC3: "IC3 - Black",
        IC4: "IC4 - Asian",
        IC5: "IC5 - Chinese, Japanese, or SE Asian",
        IC6: "IC6 - Arabic or North African",
        IC7: "IC7/0 - Unknown",
      },
    },
  },
  triageIncident: {
    reasonNotConsulted: {
      title: "Why was it not practicable to consult with a HCP?",
      options: {
        noAnswer: "Not available/no answer",
      },
    },
    howDidYouContactNhs: {
      title: "Who did you consult?",
      options: {
        healthcarePractitionerAmbulance: "Ambulance service",
        ldPractitionersInCustody: "Health care in custody",
        localHbpos: "Mental Health team at HBPOS",
        controlRoom: "Control Room - IMHT",
      },
    },
    givenHealthCareProfessionalAdvice:
      "What advice did the health/AMHP services give?",
    otherActionDetails: "Please provide a brief description of advice provided",
    whatWillYouDo: {
      136: "Section 136 (MHA)",
      56: "Section 1-6 (Mental Capacity Act)",
      voluntary: "Voluntary Support (Section 131, MHA)",
      other: "Other",
    },
    // Deliberately names no outcome: which outcomes a force can carry is
    // decided in its form definition, and wording that listed them would
    // contradict it.
    unsupportedAction:
      "This outcome is not yet available on this platform. Please continue to follow existing procedures for this incident, or contact your supervisor for more information.",
  },
  admin: {
    incidents: {
      incidentNumber: "CW Number",
    },
  },
} satisfies PartialDeep<Common>;
